import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import UpdateCliniciainProfile from './UpdateCliniciainProfile.js';

export default WithGASetup(UpdateCliniciainProfile, AuthContext);
